import { Component, ViewEncapsulation } from '@angular/core';

import { CoreBuildingBlockControlBaseComponent } from '../../shared/building-block-control-base.component';
import { CoreBuildingBlock } from '../../shared/building-block.decorator';

@CoreBuildingBlock('selection-grid')
@Component({
  selector: 'cu-selection-grid',
  styleUrls: ['./selection-grid.component.scss'],
  templateUrl: './selection-grid.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SelectionGridComponent extends CoreBuildingBlockControlBaseComponent {
  public allProductsVisible = false;
  public maxInitialProducts = 8;

  public get toggleAllProductsText(): string {
    const showLess = 'Show less options';
    const showMore = `Show ${this.field?.enum?.length - 8} more option${this.field?.enum?.length - 8 > 1 ? 's' : ''}`;
    return this.allProductsVisible ? showLess : showMore;
  }
  /**
   * Show default value
   */
  public get showDefault(): boolean {
    return !this.field.enum.find((field) => String(field.value) === this.field.data.valueString);
  }

  public selectItemValue(value) {
    this.field.data.value = value;
  }
}
